import { useState, useMemo, useEffect } from 'react';

const useReadyInteractive = () => {
  const [isInteracted, setIsInteracted] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const interactive = useMemo(() => {
    return isInteracted || isScrolled;
  }, [isInteracted, isScrolled]);

  const handleScroll = () => setIsScrolled(true);
  const handleInteraction = () => setIsInteracted(true);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('touchmove', handleScroll, { passive: true });
    window.addEventListener('mousemove', handleInteraction);
    window.addEventListener('touchstart', handleInteraction);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('touchmove', handleScroll);
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  return {
    interactive,
  };
};

export default useReadyInteractive;
